import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ProjectStore from "../store/ProjectStore";
import React from "react";
import { Row, Col, Space, Tooltip, message, Button, Modal, Image, Drawer } from "antd";
import config from "../config";
import { CarOutlined, CloseOutlined } from "@ant-design/icons";

import { Link } from "react-router-dom";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import ProjectAdd from "./ProjectAdd";
import AssignProjectToDriver from "./AssignProjectToDriver";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
class Project extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.projectStore = new ProjectStore(this);

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            loadData: 1,
            companyId: "",
            comp_value: "",
            listDataUpdate: false,
            openAssignForm: false,
            openProjectForm: false,
            projectId: "",
            projectIdEdit: "",
        };

        this.columns = [
            {
                title: context.translate("_PROJECT_NAME_"),
                dataIndex: "projectName",
                width: "10%",
                render: (val, record) => {
                    return (
                        <Link
                            onClick={(e) => {
                                e.preventDefault();
                                this.onEdit(record);
                            }}
                        >
                            {val}
                        </Link>
                    );
                },
            },
            {
                title: context.translate("_ACTION_"),
                dataIndex: "action",
                width: 6,
                ellipsis: {
                    showTitle: true,
                },
                align: "center",
                render: (_, record) => {
                    return (
                        <>
                            <Space>
                                <Tooltip
                                    // title="Assign"
                                    title={this.context.translate("_ASSIGN_")}
                                    placement="bottom"
                                    color={config.tooltipColorEdit}
                                >
                                    <CarOutlined
                                        style={{ fontSize: "15px", marginTop: "5px" }}
                                        onClick={() => {
                                            this.setState({
                                                openAssignForm: true,
                                                advertiseId: record.id,
                                                vehicleSelection: record.vehicleSelection,
                                            });
                                        }}
                                    />
                                </Tooltip>{" "}
                                {this.props.canUpdate("advertisementList") && (
                                    <Tooltip
                                        title={this.context.translate("_EDIT_RECORD_")}
                                        placement="bottom"
                                    >
                                        <Image
                                            style={{
                                                height: "19px",
                                                width: "15px",
                                                borderRadius: "0px",
                                                cursor: "pointer",
                                            }}
                                            src={editIcon}
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                await this.onEdit(record);
                                            }}
                                        ></Image>
                                    </Tooltip>
                                )}
                                {this.props.canDelete("advertisementList") && (
                                    <Tooltip
                                        title={this.context.translate("_DELETE_RECORD_")}
                                        placement="bottom"
                                    >
                                        <Image
                                            src={require("../assets/images/NewDesign/Delete.png")}
                                            style={{ cursor: "pointer", width: "15px" }}
                                            onClick={() =>
                                                this.setState({
                                                    openDeleteModal: true,
                                                    deleteData: record,
                                                })
                                            }
                                        ></Image>
                                    </Tooltip>
                                )}
                            </Space>
                        </>
                    );
                },
            },
        ];
    }

    onEdit = async (record) => {
        console.log(record)
        await this.setState({ projectIdEdit: record.projectId });
        console.log(this.state.projectIdEdit)
        await this.setState({ openProjectForm: true });
    };
    onAssign = async (record) => {
        console.log(record)
        await this.setState({ projectIdEdit: record.projectId });
        await this.setState({ openAssignForm: true });
        console.log(
            this.state.projectIdEdit
        )
    };
    async componentDidMount() {
        this.setState({ pageSize: 50, loadData: 1 });
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({ companyId: this.props.getUserData().userCompanyId });
            await this.handleSearch();

        }
    }

    async handleSearch() {
        this.setState({ loading: true });
        console.log("projectId", this.state.projectId)
        await this.projectStore.getProjectDetails(this.state.companyId, this.state.projectId);
        console.log(this.projectStore.projectList);
        await this.setState({ loadData: 1, loading: false });
    }
    async handleTableChange(pagination, filters, sorter) {
        console.log(pagination);
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.handleSearch();
    }

    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            currentPage: 1,
            pageSize: 50,
        });

        await this.handleSearch();
        await this.setState({ loadList: 1 });
    }
    async onDelete(record) {
        const response = await this.projectStore.deleteRecord({
            id: record.projectId,
        });

        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    }
    closeModal = () => {
        this.setState({ openProjectForm: false });
    };

    closeAssignModal = () => {
        this.setState({ openAssignForm: false });
    };
    responseMsg = async (resp) => {
        console.log(resp)
        if (resp.success === "S") {
            message.success(resp.message);
            await this.setState({ listDataUpdate: true });
            await this.setState({ openProjectForm: false });
            await this.handleSearch();
        } else {
            message.error(resp.message);
        }
    };
    refreshList = async () => {
        this.setState({ loading: true });
        if (this.state.companyId) {
            await this.projectStore.getProjectDetails(this.state.companyId, this.state.projectId);
        }
        this.setState({ loading: false, currentPage: 1 });
    };
    render() {
        return (
            <>

                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    style={{ width: 200 }}
                                />


                            </Space>
                        </Col>
                        <Col
                            span={8}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Tooltip
                                title={this.context.translate("_REFRESH_")}
                                placement="bottom"
                            >
                                <Image
                                    style={{
                                        height: 18,
                                        alignItems: "center",
                                        cursor: "pointer",
                                        marginInlineEnd: "20px",
                                    }}
                                    src={refreshIcon}
                                    onClick={() => this.refreshList()}
                                ></Image>
                            </Tooltip>


                            <Button
                                className="addButtonClass"
                                onClick={() =>
                                    this.setState({ openProjectForm: true, projectIdEdit: "", projectId: "" })
                                }
                            >
                                <Image
                                    style={{ marginInlineEnd: "5px", width: 13 }}
                                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                                ></Image>
                                {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                            </Button>

                        </Col>
                    </Row>
                    <ListTable
                        currentPage={this.state.currentPage}
                        total={this.projectStore?.total}
                        columns={this.columns}
                        pageSize={this.state.pageSize}
                        dataSource={this.projectStore?.projectList}
                        loading={this.projectStore?.loading}
                        onChange={this.handleTableChange}
                        rowKey="projectId"
                    />
                </div>

                {this.state.openProjectForm && (
                    <Drawer
                        className="uploadExcelDrawer"
                        // title="Driver Details"
                        width={716}
                        closeIcon={false}
                        open={this.state.openProjectForm}
                        footer={false}
                        placement={
                            this.context.locale.language === "arabic" ? "left" : "right"
                        }
                        title={
                            <div className="formTitle">
                                {this.context.translate("_PROJECT_ADD_FORM_TITLE_")}
                                <p className="formDescription">
                                    {this.context.translate("_PROJECT_ADD_FORM_DESC_")}
                                </p>
                            </div>
                        }
                        maskClosable={false}
                        onOk={() => this.setState({ openProjectForm: false })}
                        onCancel={() =>
                            this.setState({ openProjectForm: false, projectId: "", projectIdEdit: "" })
                        }
                    >
                        <div style={{ height: "100%" }}>
                            <ProjectAdd
                                projectId={this.state.projectIdEdit}
                                companyId={this.state.companyId}
                                response={this.responseMsg}
                                closeModal={this.closeModal}
                            />
                        </div>
                    </Drawer>
                )}

                {this.state.openAssignForm && (
                    <Drawer
                        className="uploadExcelDrawer"
                        // title="Driver Details"
                        width={716}
                        closeIcon={false}
                        open={this.state.openAssignForm}
                        footer={false}
                        placement={
                            this.context.locale.language === "arabic" ? "left" : "right"
                        }
                        title={
                            <div className="formTitle">
                                {this.context.translate("_PROJECT_ADD_FORM_TITLE_")}
                                <p className="formDescription">
                                    {this.context.translate("_PROJECT_ADD_FORM_DESC_")}
                                </p>
                            </div>
                        }
                        maskClosable={false}
                        onOk={() => this.setState({ openAssignForm: false })}
                        onCancel={() =>
                            this.setState({ openAssignForm: false, id: "" })
                        }
                    >
                        <div style={{ height: "100%" }}>
                            <AssignProjectToDriver
                                projectId={this.state.projectIdEdit}
                                companyId={this.state.companyId}
                                closeModal={this.closeAssignModal}
                            />
                        </div>
                    </Drawer>
                )}

                {this.state.openDeleteModal && (
                    <Modal
                        maskClosable={false}
                        title={
                            <div className="deleteModalTitle">
                                <span>
                                    {" "}
                                    {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                                </span>
                                <CloseOutlined
                                    style={{ cursor: "pointer", color: "white" }}
                                    onClick={() => this.setState({ openDeleteModal: false })}
                                />
                            </div>
                        }
                        className="deleteModal"
                        description="Are you sure you want to delete this Item? This action cannot be undone."
                        centered
                        open={this.state.openDeleteModal}
                        footer={null}
                        width={400}
                        closable={false}
                    >
                        <div className="deleteModalText">
                            <p>{this.context.translate("_DELETE_STATUS_")}</p>
                        </div>
                        <div className="deleteModalButtons">
                            <Button
                                className="deleteModalCancelButton"
                                onClick={() => this.setState({ openDeleteModal: false })}
                            >
                                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                            </Button>

                            <Button
                                className="deleteModalOkButton"
                                onClick={() => this.onDelete(this.state.deleteData)}
                            >
                                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                            </Button>
                        </div>
                    </Modal>
                )}
            </>
        );
    }
}
Project.contextType = StoreContext;
export default observer(withRouter(Project));
